// @ts-nocheck
import accesoRapidoSvg from "../../assets/images/acceso-rapido.svg";

const rapiditoButtonCls =
  "relative w-full h-full rounded-full overflow-visible flex items-center justify-center pointer-events-none";
const ctaPulseOverlayCls = "absolute inset-0 rounded-full pointer-events-none motion-safe:animate-cta-pulse";
const ringPulseCls =
  "absolute inset-0 rounded-full pointer-events-none border-2 border-[rgba(167,139,250,0.6)] motion-safe:animate-ring-pulse";
const hoverWavesCls = "absolute inset-0 pointer-events-none rounded-full";
const hoverWaveBaseCls =
  "absolute inset-0 rounded-full border-2 border-[rgba(182,186,255,0.8)] opacity-0 pointer-events-none";
const hoverWave1Cls = `${hoverWaveBaseCls} motion-safe:group-hover:animate-hover-wave`;
const hoverWave2Cls = `${hoverWaveBaseCls} motion-safe:group-hover:animate-hover-wave [animation-delay:0.3s]`;
const hoverWave3Cls = `${hoverWaveBaseCls} motion-safe:group-hover:animate-hover-wave [animation-delay:0.6s]`;
const buttonContentCls = "flex items-center justify-center w-full h-full";
const innerContentCls = "flex items-center justify-center relative w-full h-full";
const accesoRapidoIconCls =
  "w-[var(--size-25)] h-[var(--size-25)] rounded-full block transition-[width,height,filter] duration-[400ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] group-hover:w-[125px] group-hover:h-[125px] group-hover:motion-safe:animate-icon-pulse group-hover:[filter:drop-shadow(0_0_10px_rgba(251,20,40,0.85))_drop-shadow(0_0_22px_rgba(251,20,40,0.55))_drop-shadow(0_0_36px_rgba(220,10,30,0.35))]";

/**
 * Animated Rapidito icon content (visual only, no button wrapper)
 * Pure CSS animations (no Framer Motion required)
 * This component should be wrapped in a button by the parent component
 */
const RapiditoFloatingButton = ({className, ...props}) => {
  return (
    <div
      className={`${rapiditoButtonCls} ${className || ""}`}
      data-name="BOTON FLOTANTE PARTIDA FLASH"
      {...props}
    >
      {/* CTA Pulse overlay - appears every 7 seconds */}
      <div className={ctaPulseOverlayCls} />

      {/* External pulse ring */}
      <div className={ringPulseCls} />

      {/* Hover waves - appear on parent button hover */}
      <div className={hoverWavesCls}>
        <div className={hoverWave1Cls} />
        <div className={hoverWave2Cls} />
        <div className={hoverWave3Cls} />
      </div>

      <div className={buttonContentCls}>
        <div className={innerContentCls}>
          <img
            src={accesoRapidoSvg}
            className={accesoRapidoIconCls}
            alt="Acceso Rápido"
          />
        </div>
      </div>
    </div>
  );
};

export default RapiditoFloatingButton;
